import { Map } from "immutable"
import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { AsyncState, fromJSX, IOWidget, Updater } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState, ImageSize, Link } from "../../../../cms/blocks/types.gen"
import { getClassName, link } from "../../../../cms/blocks/utils.gen"
import { ModernImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen"
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types.ext.gen"
import { InnerHtmlWrapper } from "../../../../utils/InnerHtmlWrapper"

export type ButtonProps = (
  | { kind: "button"; on_click: () => Updater<CMSState> }
  | Link ) & { title: string }

export type textImageBlockProps = {
  blockIndex: number
  imageLocation: "left" | "right"
  image: ParsedMediaImage
  label?: string
  title: React.ReactNode
  introduction?: string
  text: string
  primary_button?: ButtonProps
  secondary_button?: ButtonProps
  background: "grey" | "white"
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
  get_default_data_src:(() => ImageSize)
  get_default_data_srcset:(() => [ImageSize, string][])
}

export type textImageBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  header_classname: string
  label_classname: string
  title_classname: string
  introduction_classname: string
  text_classname: string
  intro_classname: string
  footer_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
  figure_classname: string
  image_classname: string
}>

export function textImageBlock(
  props: textImageBlockProps,
  options?: { style?: textImageBlockStyle; key?: string }
): (s:CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state:PublicSiteState) =>
    fromJSX((setState) => (
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('textImage', inView, `io-${options && options.key ? options.key : props.blockIndex}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.blockIndex}`}
            className={`block block--image-text block--image-${props.imageLocation == "left" ? "left" : "right"}${props.background == "grey" ? " block--color" : ""} ls-block-spacing`}
            key={options && options.key ? options.key : `block-${props.blockIndex}`}
          >
            <div className="block__inner ls-container">
              <div className="block__content">
                <header className="block__header">
                  {props.label && (<span className="block__label">{props.label}</span>)}
                  <h2 className="block__title title--m">{props.title}</h2>
                </header>

                {props.introduction &&  
                  <div className="block__text">
                  {/* <div className="block__intro text--styled text--spacing" dangerouslySetInnerHTML={{ __html: props.introduction }} /> */}
                  <InnerHtmlWrapper className="block__intro text--styled text--spacing" text={props.introduction} />
                  </div>
                }

                {props.primary_button || props.secondary_button
                  ? <footer className="block__footer">
                      {props.primary_button && (
                        <div className="block__clickable">
                          {props.primary_button.kind === "button" ? (
                            <button
                              className="linklink"
                              onClick={() => props.primary_button.kind === "button" && setState(props.primary_button.on_click())}
                            >
                              {props.primary_button.title}
                            </button>
                          ) : props.primary_button.title && props.primary_button.url
                            ? (link(props.primary_button,
                                    {classname: 'linklink'},
                                    props.primary_button.title,
                                    () => {
                                      window.dataLayer.push({
                                        event: `event.${sitename}`,
                                        category: 'ImageTextBlock',
                                        action: props.primary_button.title,
                                        label: window.location.pathname,
                                      })
                                    }))
                            : null
                          }
                        </div>
                      )}
                      
                      {props.secondary_button && (
                        <div className="block__clickable">
                          {props.secondary_button.kind === "button" ? (
                            <button
                              className="link"
                              onClick={() => props.secondary_button.kind === "button" && setState(props.secondary_button.on_click())}
                            >
                              {props.secondary_button.title}
                            </button>
                          ) : props.secondary_button.title && props.secondary_button.url
                            ? (link(props.secondary_button,
                                    {classname: "link"},
                                    props.secondary_button.title,
                                    () => {
                                      window.dataLayer.push({
                                        event: `event.${sitename}`,
                                        category: 'ImageTextBlock',
                                        action: props.secondary_button.title,
                                        label: window.location.pathname,
                                      })
                                    }))
                            : null
                          }
                        </div>
                      )}
                    </footer>
                  : null
                }
              </div>

              <div className="block__visual">
                {s.images.has(props.image?.field_media_image?.image?.id) &&
                  ModernImageContainer(
                    s.images.get(props.image?.field_media_image?.image?.id),
                    "block__image",
                    props.image.field_media_image.alt,
                    props.get_default_data_src,
                    props.get_default_data_srcset
                  ).run(_ => { })
                }
              </div>
            </div>
          </InView>
        ))
}
